export const PHONE_NUMBER = '949-883-6002';
export const PHONE_LINK = 'tel:+19498836002';
export const FINAL_FORM_ID = 'jos-final-contact-form';

export function addContactNavigation(root) {
  const document = root.ownerDocument;
  const finalPanel = root.querySelector('.jil-ct-formbox-169');
  if (finalPanel) finalPanel.id = FINAL_FORM_ID;
  const language = root.querySelector('#jil-id-lang-187');
  if (!language || root.querySelector('#jos-header-contact-actions')) return;
  const actions = document.createElement('div');
  actions.id = 'jos-header-contact-actions';
  actions.className = 'jos-header-contact-actions';
  actions.setAttribute('role', 'group');
  actions.setAttribute('aria-label', 'Contact and language');
  const phone = document.createElement('a');
  phone.id = 'jos-header-phone-link';
  phone.className = 'jos-header-phone-link notranslate';
  phone.href = PHONE_LINK;
  phone.setAttribute('translate', 'no');
  phone.setAttribute('aria-label', `Call Jos Immigration Law at ${PHONE_NUMBER}`);
  const icon = root.querySelector(`a[href="${PHONE_LINK}"] svg`)?.cloneNode(true);
  if (icon) phone.appendChild(icon);
  phone.appendChild(document.createTextNode(PHONE_NUMBER));
  language.before(actions);
  actions.append(phone, language);
}